exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".modal{background:rgba(0,0,0,.6)}.modal-dialog{margin:25% auto}.modal-header{text-align:center;font-size:larger;font-weight:700}.modal-footer{text-align:left}", "", {"version":3,"sources":["/opt/snt/front-end-turnos/src/app/turnos/shared/modal/modal.component.scss"],"names":[],"mappings":"AAAA,OACI,yBAA8B,CACjC,cAGG,eAAgB,CACnB,cAGG,kBAAkB,iBACD,eACA,CACpB,cAGG,eAAgB,CACnB","file":"modal.component.scss","sourcesContent":[".modal {\r\n    background: rgba(0, 0, 0, 0.6);\r\n}\r\n\r\n.modal-dialog {\r\n    margin: 25% auto;\r\n}\r\n   \r\n.modal-header {\r\n    text-align: center;\r\n    font-size: larger;\r\n    font-weight: bold;\r\n}\r\n\r\n.modal-footer {\r\n    text-align: left;\r\n}"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/snt/front-end-turnos/src/app/turnos/shared/modal/modal.component.scss
// module id = 8/Ja
// module chunks = 2